import Splide from "@splidejs/splide";
import GLightbox from "glightbox";
import  "@google/model-viewer";
import "cookieconsent";

document.addEventListener("DOMContentLoaded", function (event) {
    
    // Externe Links im Content-Bereich markieren
    const contentAreas = document.querySelectorAll('.section_text, .item_content, .section_supporters, .text, .item_details');
    contentAreas.forEach(area => {
        const externalLinks = area.querySelectorAll('a[href^="http"]:not([href*="eutiner-koepfe"]), a[href^="//"]:not([href*="eutiner-koepfe"])');
        externalLinks.forEach(link => {
            link.setAttribute('target', '_blank');
            link.classList.add('external-link');
        });
    });

    //Show hide
    let showHideElements = [...document.querySelectorAll('[data-behaviour="showhide"]')];

    showHideElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            element.parentNode.classList.toggle("showhide--selected")

            showHideElements.filter(e => e != element).forEach((e) => e.parentNode.classList.remove("showhide--selected"));
            setTimeout(() => {
                // console.log(element.scrollTop);
                // window.scrollTo({
                //     top: element.parentNode.scrollTop,
                //     behavior: 'smooth',
                // });
                element.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 500);
        })
    });

    document.querySelector('[data-behaviour="menubutton"]').addEventListener("click", () => {
        document.body.classList.toggle('body--shownav');
    });

    const slides = [...document.querySelectorAll('.splide')];
    if(slides.length) {
        slides.forEach((splideElement) => {
            new Splide(splideElement, {
                perPage: 3,
                rewind: true,
                breakpoints: {
                    700: {
                        perPage: 1,
                    },
                }
            }).mount();
        });
    }

    const lightbox = new GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // Cookie, Matomo
    var _paq = window._paq = window._paq || [];

    function addAnalytics() {
        var u="//matomo.atw.io/";
        _paq.push(['setVisitorCookieTimeout', 2880]); // 2 days
        _paq.push(['setReferralCookieTimeout', 2880]); // 2 days
        _paq.push(['setSessionCookieTimeout', 0]); // session only
        _paq.push(["setTrackerUrl", u+"matomo.php"]);
        _paq.push(["setSiteId", "32"]);
        _paq.push(['enableHeartBeatTimer', 30]);
        _paq.push(["trackPageView"]);
        _paq.push(["enableLinkTracking"]);

        var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0]; g.type="text/javascript";
        g.defer=true; g.async=true; g.src=u+"matomo.js"; s.parentNode.insertBefore(g,s);

        console.log('MATOMO Tracking enabled')
    }

    function optOut(){
        _paq.push(["disableCookies"]);
        _paq.push(["deleteCookies"]);
        // location.reload();

        console.log('MATOMO Tracking disabled')
    }

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "rgba(255, 255, 255, 0.95)",
                "text": "#3D3D3D",
            },
            "button": {
                "background": "#314151",
                "text": "#ffffff"
            }
        },
        "position": "bottom-right",
        "theme": "edgeless",
        "type": "opt-in",
        "content": {
            "message": "Wir verwenden Tracking-Cookies für anonymisierte Nutzungsstatistiken.",
            "allow": "Einverstanden",
            "deny": "Ablehnen",
            "link": "Mehr erfahren",
            "href": "/datenschutz",
            "policy": 'Cookie Einstellungen'
        },
        onInitialise: function (status) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onRevokeChoice: function () {
            optOut();
        },
    });
});
